import React from 'react';
import "./thanks.scss";
import img from "./binance.png";
import { useAppData } from '../../AppContext';
import { useTranslation } from 'react-i18next';
import dollar_coin from "../../pages/dollar_coin.png"
import { sendCoinsAndEnergy } from '../../http';
import { formatNumber } from '../../Utils/formatNumber';
function ThanksNiki({ onClick, coins }) {
    const { t } = useTranslation();
    const { handleEditCoins, setpassiveIncome } = useAppData();

    const handleClick = () => {
        
        handleEditCoins(coins);
        sendCoinsAndEnergy(coins,0)
        setpassiveIncome(0);
    };

    return (
        <div className='outer_container_thanks'>
            <div className='content_thanks'>
                <div className='binance_container'>
                    <img src={img} alt="Binance Logo" className="binance_logo" />
                </div>
                <div className='coin_display'>
                    <img src={dollar_coin}/>
                    <div className='coin_amount'>{formatNumber(coins)}</div>
                </div>
                <div className='message'>
                    {t('The exchange has started working for you')}
                </div>
            </div>
           
            <button className='button_thanks' onClick={handleClick}>
                {t('Thank you, Binance 💜')}
            </button>
        </div>
    );
}

export default ThanksNiki;
